import { BI_CHANGE_ORDERING, BI_DISCARD_COMMENT, BI_OPEN_COMMENT_ACTIONS, BI_SELECT_COMMENT_ACTION, BI_SHOW_ZERO_COMMENTS_EMPTY_STATE, BI_SHOW_FALLBACK_STATE, BI_VISIT_MEMBER_PROFILE, BI_ATTEMPT_LOGIN_SIGNUP, BI_INITIATE_FILE_UPLOAD, BI_INITIATE_IMAGE_UPLOAD, BI_INITIATE_REACTION, BI_CLICK_SHOW_MORE_BTN, BI_CLICK_PUBLISH_SELECT_BTN, BI_CAPTCHA_EVENT, BI_OPEN_REACTION_LIST, BI_CLICK_EMOTION_LIST_TAB, BI_COMMENT_FORM_EXPANDED, } from '../store/actions/bi-actions';
import { CREATE_COMMENT_FAILURE, CREATE_COMMENT_REQUEST, CREATE_COMMENT_SUCCESS, DELETE_COMMENT_FAILURE, DELETE_COMMENT_SUCCESS, RETRY_CREATE_COMMENT_REQUEST, UPDATE_COMMENT_FAILURE, UPDATE_COMMENT_REQUEST, UPDATE_COMMENT_SUCCESS, } from '../store/comments/top-level-comments/top-level-comments-crud-actions';
import { FETCH_COMMENTS_SUCCESS, FETCH_NEXT_REPLIES_REQUEST, FETCH_NEXT_COMMENTS_REQUEST, FETCH_PREV_REPLIES_REQUEST, FETCH_PREV_COMMENTS_REQUEST, VIEW_REPLY_TARGET_REQUEST, VIEW_REPLY_TARGET_DELETED, VIEW_REPLY_TARGET_AVAILABLE, FETCH_NEXT_COMMENTS_FAILURE, FETCH_PREV_COMMENTS_FAILURE, FETCH_NEXT_REPLIES_FAILURE, FETCH_PREV_REPLIES_FAILURE, VIEW_REPLY_TARGET_FAILURE, } from '../store/comments/paging/comments-paging-actions';
import { REACT_TO_COMMENT_FAILURE, REACT_TO_COMMENT_SUCCESS, } from '../store/comments/reactions/comments-reaction-actions';
import { CREATE_REPLY_FAILURE, CREATE_REPLY_REQUEST, CREATE_REPLY_SUCCESS, DELETE_REPLY_FAILURE, DELETE_REPLY_SUCCESS, INIT_REPLY, UPDATE_REPLY_FAILURE, UPDATE_REPLY_REQUEST, UPDATE_REPLY_SUCCESS, } from '../store/comments/replies/replies-crud-actions';
import { getCommentById, getCommentStateById } from '../store/comments/comments-selectors';
import { getTextCharCount, getContentEntityData, ReactionCodeBIMap, getTabName } from './bi-utils';
import { getCurrentMember } from '../store/members/members-selectors';
import { getInstanceValues } from '../store/base-params/base-params-selectors';
import { REVEAL_LIVE_COMMENTS, REVEAL_LIVE_REPLIES, } from '../store/comments/live-updates/live-updates-actions';
import { FOLLOW_MEMBER_SUCCESS, UNFOLLOW_MEMBER_SUCCESS, } from '../store/member-follow/member-follow-actions';
import { settingsTurnOffComments, goToMemberProfile, dotsActionButtonOpenActions, commentsSort, dotsActionButtonActionClick, cancelWritingEditingComment, emptyStateShown, customErrorPageRendered, logInSignUpToComment, imageStartUploading, fileUploaded, commentsListLoaded, likeClicked, likePublished, replyingOnClicked, loadMoreClick, attemptToPublishCommentReply, commentReplyPublished, readMoreClicked, publishButtonClick, captchaOnCommentReplyPublish, viewNewCommentClicked, whoLikedReactedClick, listOfReactionsClickOnTab, followMember, commentsUpvoteDownvoteClick, deleteCommentReply, intentClickCommentReply, } from '@wix/bi-logger-comments-uou/v2';
import { createActionMatcher } from './create-action-matcher';
import { errorForBi } from '../store/comments/comments-errors';
import { Ordering } from '../common-enums';
import { VOTE_ON_COMMENT_SUCCESS } from '../store/comments/votes/comments-vote-actions';
import { canHaveVotes } from '../store/comments/top-level-comments/top-level-comment-types';
import { getActualVotesScore } from '../store/comments/votes/comments-vote-utils';
const ORIGIN = 'comments_page';
const COMMENT = 'comment';
const REPLY = 'reply';
export const biEventsExecutor = ({ action, state, logger }) => {
    createActionMatcher(logger)
        // very weird bi function name, but it's for error toasts
        .match([CREATE_REPLY_FAILURE, CREATE_COMMENT_FAILURE], settingsTurnOffComments, (action) => ({
        attempt_type: 'new',
        error_message: errorForBi(action.payload.error),
        type: action.type === CREATE_REPLY_FAILURE ? REPLY : COMMENT,
        parent_resource_id: action.payload.resourceId,
    }))
        .match([UPDATE_REPLY_FAILURE, UPDATE_COMMENT_FAILURE], settingsTurnOffComments, (action) => ({
        attempt_type: 'edit',
        error_message: errorForBi(action.payload.error),
        type: action.type === UPDATE_REPLY_FAILURE ? REPLY : COMMENT,
        parent_resource_id: action.payload.resourceId,
    }))
        .match([DELETE_REPLY_FAILURE, DELETE_COMMENT_FAILURE], settingsTurnOffComments, (action) => ({
        attempt_type: 'delete',
        error_message: errorForBi(action.payload.error),
        type: action.type === DELETE_REPLY_FAILURE ? REPLY : COMMENT,
        parent_resource_id: action.payload.resourceId,
    }))
        .match([REACT_TO_COMMENT_FAILURE], settingsTurnOffComments, (action) => ({
        attempt_type: 'react',
        error_message: errorForBi(action.payload.error),
        type: 'any',
        parent_resource_id: action.payload.resourceId,
    }))
        .match([VIEW_REPLY_TARGET_FAILURE], settingsTurnOffComments, (action) => ({
        attempt_type: 'view-reply',
        error_message: errorForBi(action.payload.error),
        type: REPLY,
        parent_resource_id: action.payload.resourceId,
    }))
        .match([
        FETCH_NEXT_COMMENTS_FAILURE,
        FETCH_PREV_COMMENTS_FAILURE,
        FETCH_NEXT_REPLIES_FAILURE,
        FETCH_PREV_REPLIES_FAILURE,
    ], settingsTurnOffComments, (action) => ({
        error_message: errorForBi(action.payload.error),
        parent_resource_id: action.payload.resourceId,
        attempt_type: 'paging',
        type: action.type === FETCH_NEXT_REPLIES_FAILURE || action.type === FETCH_PREV_REPLIES_FAILURE
            ? REPLY
            : COMMENT,
    }))
        .match([BI_VISIT_MEMBER_PROFILE], goToMemberProfile, (action) => {
        const currentMember = getCurrentMember(state);
        return {
            origin: ORIGIN,
            is_my_profile: currentMember?.id === action.payload.memberId,
            parent_resource_id: action.payload.resourceId,
        };
    })
        .match([BI_OPEN_COMMENT_ACTIONS], dotsActionButtonOpenActions, (action) => ({
        type: action.payload.type,
        origin: ORIGIN,
        parent_resource_id: action.payload.resourceId,
        comment_id: action.payload.commentId,
    }))
        .match([BI_CHANGE_ORDERING], commentsSort, (action) => ({
        sort_by: action.payload.sortBy === Ordering.OLDEST_FIRST ? 'oldest' : 'newest',
        origin: ORIGIN,
        parent_resource_id: action.payload.resourceId,
    }))
        .match([BI_SELECT_COMMENT_ACTION], dotsActionButtonActionClick, (action) => ({
        origin: ORIGIN,
        action: action.payload.action,
        type: action.payload.type,
        parent_resource_id: action.payload.resourceId,
        comment_id: action.payload.commentId,
    }))
        .match([BI_DISCARD_COMMENT], cancelWritingEditingComment, (action) => ({
        type: action.payload.type,
        parent_resource_id: action.payload.resourceId,
    }))
        .match([BI_SHOW_ZERO_COMMENTS_EMPTY_STATE], emptyStateShown, (action) => {
        const { uid = '' } = getInstanceValues(state);
        return { uuid: uid, parent_resource_id: action.payload.resourceId };
    })
        .match([BI_SHOW_FALLBACK_STATE], customErrorPageRendered, (action) => ({
        parent_resource_id: action.payload.resourceId,
    }))
        .match([BI_ATTEMPT_LOGIN_SIGNUP], logInSignUpToComment, (action) => ({
        type: action.payload.type,
        parent_resource_id: action.payload.resourceId,
    }))
        .match([BI_INITIATE_IMAGE_UPLOAD], imageStartUploading, 
    // @ts-expect-error TODO:remove when schema package is updated with correct fields
    (action) => ({
        type: action.payload.isReply ? REPLY : COMMENT,
        origin: ORIGIN,
        parent_resource_id: action.payload.resourceId,
    }))
        .match([BI_INITIATE_FILE_UPLOAD], fileUploaded, 
    // @ts-expect-error TODO:remove when schema package is updated with correct fields
    (action) => ({
        type: action.payload.isReply ? REPLY : COMMENT,
        parent_resource_id: action.payload.resourceId,
    }))
        .match([FETCH_COMMENTS_SUCCESS], commentsListLoaded, (action) => ({
        comments_count: action.payload.response.totalComments,
        parent_resource_id: action.payload.resourceId,
    }))
        .match([BI_INITIATE_REACTION], likeClicked, (action) => {
        const { subaction, resourceId, commentId, reactionCode } = action.payload;
        const comment = getCommentById(state, resourceId)(commentId);
        return {
            flag: subaction !== 'REMOVE',
            type: comment?.replyTo ? REPLY : COMMENT,
            parent_resource_id: resourceId,
            comment_id: commentId,
            reaction_type: ReactionCodeBIMap[reactionCode],
            action: action.payload.subaction.toLowerCase(),
            origin: ORIGIN,
        };
    })
        .match([REACT_TO_COMMENT_SUCCESS], likePublished, (action) => {
        const { resourceId, subaction, commentId } = action.payload;
        const comment = getCommentById(state, resourceId)(commentId);
        return {
            flag: subaction !== 'REMOVE',
            type: comment?.replyTo ? REPLY : COMMENT,
            origin: ORIGIN,
            parent_resource_id: resourceId,
            comment_id: commentId,
            reaction_type: ReactionCodeBIMap[action.payload.reactionCode],
            action: action.payload.subaction.toLowerCase(),
        };
    })
        .match([VIEW_REPLY_TARGET_AVAILABLE, VIEW_REPLY_TARGET_DELETED, VIEW_REPLY_TARGET_REQUEST], replyingOnClicked, (action) => {
        const { resourceId, targetCommentId } = action.payload;
        const comment = getCommentById(state, resourceId)(targetCommentId);
        const instance = getInstanceValues(state);
        return {
            uuid: instance.uid ?? '',
            // top level comment is always present in the state
            type: comment && !comment?.replyTo ? COMMENT : REPLY,
            comment_id: targetCommentId,
            parent_resource_id: resourceId,
        };
    })
        // ------loadMoreAttempt
        .match([FETCH_NEXT_REPLIES_REQUEST, FETCH_NEXT_COMMENTS_REQUEST], loadMoreClick, (action) => {
        return {
            type: action.type === FETCH_NEXT_COMMENTS_REQUEST ? COMMENT : REPLY,
            action: 'next',
            origin: ORIGIN,
            parent_resource_id: action.payload.resourceId,
        };
    })
        .match([FETCH_PREV_REPLIES_REQUEST, FETCH_PREV_COMMENTS_REQUEST], loadMoreClick, (action) => {
        return {
            type: action.type === FETCH_PREV_COMMENTS_REQUEST ? COMMENT : REPLY,
            action: 'prev',
            origin: ORIGIN,
            parent_resource_id: action.payload.resourceId,
        };
    })
        // ------attemptToPublishCommentReply
        .match([CREATE_COMMENT_REQUEST, RETRY_CREATE_COMMENT_REQUEST, CREATE_REPLY_REQUEST], attemptToPublishCommentReply, (action) => {
        let isGuestFlow;
        const { resourceId, asGuest } = action.payload;
        const commentState = state.comments[resourceId];
        if (commentState?.type !== 'READY') {
            return;
        }
        const currentMember = getCurrentMember(state);
        if (action.type === CREATE_COMMENT_REQUEST ||
            action.type === RETRY_CREATE_COMMENT_REQUEST) {
            const hasPermission = commentState.configs.permissions.permissions.createComment;
            isGuestFlow = hasPermission && !currentMember;
        }
        if (action.type === CREATE_REPLY_REQUEST) {
            const commentId = action.payload.targetId;
            const comment = getCommentById(state, resourceId)(commentId);
            if (comment?.status === 'PUBLISHED') {
                const hasPermission = commentState.configs.permissions.permissions.createReply;
                isGuestFlow = hasPermission && !currentMember;
            }
        }
        return {
            type: action.type === CREATE_REPLY_REQUEST ? REPLY : COMMENT,
            attempt_type: 'new',
            symbol_count: getTextCharCount(action.payload.content),
            parent_resource_id: resourceId,
            origin: ORIGIN,
            publish_type: isGuestFlow
                ? asGuest
                    ? 'publish_as_guest'
                    : 'publish_as_member'
                : currentMember
                    ? 'logged_in_member'
                    : 'sign_in',
        };
    })
        .match([UPDATE_COMMENT_REQUEST, UPDATE_REPLY_REQUEST], attemptToPublishCommentReply, (action) => ({
        type: action.type === UPDATE_COMMENT_REQUEST ? COMMENT : REPLY,
        attempt_type: 'edit',
        symbol_count: getTextCharCount(action.payload.content),
        parent_resource_id: action.payload.resourceId,
        publish_type: 'logged_in_member',
        origin: ORIGIN,
    }))
        // ------commentReplyPublished
        .match([CREATE_COMMENT_SUCCESS, UPDATE_COMMENT_SUCCESS], commentReplyPublished, 
    // @ts-expect-error we need to provide id string or null for 'parent_comment_id', but bi schema doesnt generate correct types here
    (action) => {
        const { rating, comment } = action.payload;
        if (!comment.content?.richContent) {
            return;
        }
        const contentData = getContentEntityData(comment.content?.richContent);
        return {
            type: COMMENT,
            is_edited: action.type === UPDATE_COMMENT_SUCCESS,
            ...contentData,
            parent_resource_id: action.payload.resourceId,
            comment_id: comment.commentId,
            published_as_guest: action.payload.comment.author?.identityType === 'ANONYMOUS',
            parent_comment_id: comment.replyTo?.commentId ?? null,
            request_duration: action.payload.requestDuration,
            ...(rating ? { rating } : {}),
        };
    })
        .match([CREATE_REPLY_SUCCESS, UPDATE_REPLY_SUCCESS], commentReplyPublished, 
    // @ts-expect-error we need to provide id string or null for 'parent_comment_id', but bi schema doesnt generate correct types here
    (action) => {
        const { comment } = action.payload;
        if (!comment.content?.richContent) {
            return;
        }
        const contentData = getContentEntityData(comment.content?.richContent);
        return {
            type: REPLY,
            is_edited: action.type === UPDATE_REPLY_SUCCESS,
            ...contentData,
            parent_resource_id: action.payload.resourceId,
            comment_id: comment.commentId,
            published_as_guest: action.payload.comment.author?.identityType === 'ANONYMOUS',
            parent_comment_id: comment.replyTo?.commentId ?? null,
            request_duration: action.payload.requestDuration,
        };
    })
        .match([DELETE_COMMENT_SUCCESS, DELETE_REPLY_SUCCESS], deleteCommentReply, (action) => {
        return {
            type: action.type === DELETE_COMMENT_SUCCESS ? COMMENT : REPLY,
            comment_id: action.payload.commentId,
            parent_resource_id: action.payload.resourceId,
            parent_comment_id: action.type === DELETE_COMMENT_SUCCESS ? action.payload.resourceId : action.meta.parentId,
            container_id: '',
            container_type: '',
        };
    })
        .match([INIT_REPLY, BI_COMMENT_FORM_EXPANDED], intentClickCommentReply, (action) => {
        return {
            type: action.type === INIT_REPLY ? REPLY : COMMENT,
            parent_resource_id: action.payload.resourceId,
            origin: ORIGIN,
        };
    })
        .match([BI_CLICK_SHOW_MORE_BTN], readMoreClicked, 
    // @ts-expect-error we need to provide id string or null for 'parent_comment_id', but bi schema doesnt generate correct types here
    (action) => {
        const { isShowMore, resourceId, commentId } = action.payload;
        const comment = getCommentById(state, resourceId)(commentId);
        return {
            action: isShowMore ? 'more' : 'less',
            parent_resource_id: resourceId,
            type: comment?.replyTo ? REPLY : COMMENT,
            origin: ORIGIN,
            parent_comment_id: comment?.replyTo?.commentId ?? null,
        };
    })
        .match([BI_CLICK_PUBLISH_SELECT_BTN], publishButtonClick, (action) => {
        const { resourceId, isReply } = action.payload;
        return {
            parent_resource_id: resourceId,
            type: isReply ? REPLY : COMMENT,
        };
    })
        .match([BI_CAPTCHA_EVENT], captchaOnCommentReplyPublish, (action) => {
        const { resourceId, userAction } = action.payload;
        const captchaSuccess = action.payload.step === 'COMPLETE' ? action.payload.isSuccess : null;
        return {
            captcha_success: captchaSuccess,
            type: userAction === 'CREATE_COMMENT' ? COMMENT : REPLY,
            parent_resource_id: resourceId,
            captcha_step: action.payload.step === 'SHOW' ? 1 : 2,
        };
    })
        .match([REVEAL_LIVE_COMMENTS], viewNewCommentClicked, (action) => ({
        type: COMMENT,
        parent_resource_id: action.payload.resourceId,
        origin: ORIGIN,
    }))
        .match([REVEAL_LIVE_REPLIES], viewNewCommentClicked, (action) => ({
        type: REPLY,
        parent_resource_id: action.payload.resourceId,
        origin: ORIGIN,
    }))
        .match([BI_OPEN_REACTION_LIST], whoLikedReactedClick, (action) => {
        const { type, commentId, resourceId } = action.payload;
        const comment = getCommentById(state, resourceId)(commentId);
        return {
            comment_id: commentId,
            parent_resource_id: resourceId,
            reaction_type: type === 'likes' ? 'likes' : 'reactions',
            type: comment?.replyTo ? REPLY : COMMENT,
            origin: ORIGIN,
        };
    })
        .match([BI_CLICK_EMOTION_LIST_TAB], listOfReactionsClickOnTab, (action) => {
        const { resourceId, tabName, commentId } = action.payload;
        return {
            parent_resource_id: resourceId,
            tab_name: getTabName(tabName),
            comment_id: commentId,
        };
    })
        .match([FOLLOW_MEMBER_SUCCESS], followMember, (action) => ({
        member_followed: action.payload.memberId,
        flag: true,
        origin: ORIGIN,
    }))
        .match([UNFOLLOW_MEMBER_SUCCESS], followMember, (action) => ({
        member_followed: action.payload.memberId,
        flag: false,
        origin: ORIGIN,
    }))
        .match([VOTE_ON_COMMENT_SUCCESS], commentsUpvoteDownvoteClick, (action) => {
        const { biInfo: { transition }, commentId, resourceId, } = action.payload;
        const commentState = getCommentStateById(state, resourceId)(commentId);
        const [finalScore, isMarked] = (() => {
            if (!commentState || !canHaveVotes(commentState)) {
                return [0, false];
            }
            return [getActualVotesScore(commentState.votes), !!commentState.comment.isMarked];
        })();
        const action_type = (() => {
            if (transition.to === 'DOWNVOTE' || transition.to === 'UPVOTE') {
                return transition.to.toLowerCase();
            }
            // to neutral
            return transition.from === 'UPVOTE' ? 'unupvote' : 'undownvote';
        })();
        return {
            action_type,
            final_state: finalScore,
            comment_id: commentId,
            origin: ORIGIN,
            type: COMMENT,
            parent_resource_id: resourceId,
            is_best_answer: isMarked,
        };
    })
        .execute(action);
};
//# sourceMappingURL=bi-events.js.map